export default "__VITE_ASSET__C7DEZLP7__"